import React, { useState } from "react";
import {
  Box,
  Typography,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const GitStatusCell = ({ row }) => {
  const [open, setOpen] = useState(false);

  const getColor = (status) => {
    const lower = status?.toLowerCase();

    if (lower?.includes("completed")) return "#15803d";
    if (lower?.includes("success")) return "#15803d";
    if (lower?.includes("failed")) return "#b91c1c";
    if (lower?.includes("queued")) return "#2563eb";
    if (lower?.includes("progress")) return "#d97706";

    return "#64748b";
  };

  const isFailed =
    row?.gitStatus?.toLowerCase()?.includes("failed");

  const isCompleted =
    row?.gitStatus?.toLowerCase()?.includes("completed") ||
    row?.gitConclusion?.toLowerCase()?.includes("success");

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          // minWidth: 180,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            fontWeight="700"
            color={getColor(row?.gitStatus)}
          >
            {row?.gitStatus || "-"}
          </Typography>

         {/* {row?.gitRunId && (
  <Typography
    variant="caption"
    color="primary"
    sx={{
      display: "block",
      textDecoration: "underline",
    }}
  >
    Run ID: {row.gitRunId}
  </Typography>
)} */}
        </Box>

        {(isCompleted || isFailed) && (
          <Tooltip title="View Details">
            <IconButton
              size="small"
              onClick={() => setOpen(true)}
            >
              {isFailed ? (
                <WarningAmberIcon
                  sx={{
                    color: "#b91c1c",
                    fontSize: 18,
                  }}
                />
              ) : (
                <InfoOutlinedIcon
                  sx={{
                    color: "#15803d",
                    fontSize: 18,
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          GitHub Run Details
        </DialogTitle>

        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              mt: 1,
            }}
          >
            <Box display="flex">
              <Typography
                fontWeight={700}
                sx={{ minWidth: 120 }}
              >
                Status:
              </Typography>

              <Typography
                color={getColor(row?.gitStatus)}
              >
                {row?.gitStatus || "-"}
              </Typography>
            </Box>
 <Box display="flex">
              <Typography
                fontWeight={700}
                sx={{ minWidth: 120 }}
              >
                 Run ID:
              </Typography>

              <Typography
                // color={getColor(row?.gitStatus)}
                color= "primary"
              >
                {row?.gitRunId || "-"}
              </Typography>
            </Box>

        

            <Box display="flex">
              <Typography
                fontWeight={700}
                sx={{ minWidth: 120 }}
              >
                Message:
              </Typography>

              <Typography
                color="text.secondary"
                sx={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {row?.resourceHandlerMessage ||
                  "No message available"}
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GitStatusCell;